export default {
      id: "checkbox-ticked-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#checkbox-ticked",
      toString: function () {
        return this.url;
      }
    }